import Cookies from 'js-cookie';

import { COOKIES } from '../constants/cookies';
import {
    AUTH0_CLAIM_REFRESH_STORAGE_KEY,
    AUTOSHIP_CACHE_KEY,
    CHATBOT_CACHE_KEY,
    FAVORITES_LOCAL_STORAGE_KEY,
    LOYALTY_LOCAL_STORAGE_KEY,
} from '../constants/localStorage';

export function clearFavorites() {
    window.localStorage.removeItem(FAVORITES_LOCAL_STORAGE_KEY);
}

export function clearLoyaltyData() {
    window.localStorage.removeItem(LOYALTY_LOCAL_STORAGE_KEY);
}

/**
 * Drops the Auth0 claim-refresh cooldown so the next session starts with a fresh attempt
 * budget instead of inheriting the back-off of the account that just signed out.
 */
export function clearAuth0ClaimsRefreshState() {
    globalThis.window.localStorage.removeItem(AUTH0_CLAIM_REFRESH_STORAGE_KEY);
}

export function clearAutoshipDataCache() {
    window.localStorage.removeItem(AUTOSHIP_CACHE_KEY);
}

export function clearChatData() {
    localStorage.removeItem(CHATBOT_CACHE_KEY);
    Cookies.remove(COOKIES.X_PETM_GHATBOT_THREAD);
    Cookies.remove(COOKIES.X_PETM_GUEST_TOKEN);
}
